import { gql } from "apollo-server-micro";
import { VEHICLE_LIST_DATA_FRAGMENT } from "../fragments/vehicle";

export const GET_USER_WATCHLIST = gql`
  ${VEHICLE_LIST_DATA_FRAGMENT}
  query getUserWatchlist {
    getUserWatchlist {
      ...VehicleListData
    }
  }
`;

export const GET_WATCHLISTS = gql`
  query getWatchlists(
    $query: String # PROPERTIES HERE
  ) {
    getWatchlists(
      query: $query # PROPERTIES HERE
    ) {
      _id
      # PROPERTIES HERE
    }
  }
`;
/* BOILERPLATER_INJECT_QUERY */
